import './bootstrap';
import '../css/app.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-chat-elements/dist/main.css';

import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from React 18
import { createInertiaApp } from '@inertiajs/react';
import { getCsrfCookie } from './api'; // Import the function

// Create Inertia app
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

// Webpack context keys include their file extension, while Laravel sends Inertia component
// names such as "Movies/EditPoster". Resolve both supported extensions explicitly instead of
// relying on Webpack's extension inference inside a dynamic require().
const inertiaPageModules = require.context('./Pages', true, /\.(js|jsx)$/);
const inertiaPageKeys = new Set(inertiaPageModules.keys());

const resolveInertiaPage = (name) => {
  const pageKey = [`./${name}.js`, `./${name}.jsx`]
    .find((candidate) => inertiaPageKeys.has(candidate));

  if (!pageKey) {
    throw new Error(`Cannot find Inertia page "${name}".`);
  }

  return inertiaPageModules(pageKey);
};

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  progress: {
    delay: 250,
    color: '#29d',
    includeCSS: true,
    showSpinner: true,
  },
  resolve: resolveInertiaPage,
  setup({ el, App, props }) {
    // Fetch the CSRF cookie when the app is initialized
    getCsrfCookie().then(() => {
      const root = createRoot(el); // Create the root for React 18
      root.render(<App {...props} />); // Render the Inertia app
    });
  },
});

import ScriptSnout from './Pages/ScriptSnout/ScriptSnout';

// document.addEventListener('DOMContentLoaded', () => {
//   const widgetEl = document.getElementById('script-snout-widget');
//   if (widgetEl) {
//     const props = JSON.parse(widgetEl.dataset.props || '{}');
//     createRoot(widgetEl).render(<div>Hello from React</div>);
//     // createRoot(widgetEl).render(<ScriptSnout movie={props} />);
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const widgetEl = document.getElementById('script-snout-widget');
  if (widgetEl) {
    const props = JSON.parse(widgetEl.dataset.props || '{}');
    createRoot(widgetEl).render(<ScriptSnout movie={props} />);
    // createRoot(widgetEl).render(<div>Hello from React</div>);
  }
});
